<template>
  <Record class="RecordImage">
    <Field
      slot="title"
      class="nameLabel"
      :class="{ rawName: !image.label }"
      :disabled="isSaving"
      :value.sync="labelName"
      @focusout="saveFileName">
      <Loader
        v-if="isSaving"
        class="sm" />
    </Field>
    <div class="image">
      <Pic
        :src="getFileUrl(image)" />
    </div>
    <Row>
      <Column :xs="6">
        <Set icon="weight">
          {{ image.size | metricNumber }}
        </Set>
      </Column>
      <Column :xs="6">
        <Set icon="expand-left">
          {{ image.width }} x {{ image.height }}
        </Set>
      </Column>
    </Row>
    <ImageTags
      slot="between"
      :image="image" />
    <RecordActions
      slot="actions"
      :doShowDelete="false"
      name="image"
      :record="image"
      routeName="Image">
      <Field
        slot="tail"
        class="sm ib"
        :disabled="isSaving"
        :isSwitch="true"
        :label="$t('embeddings')"
        type="checkbox"
        :value="image.doEmbed"
        @update:value="setDoEmbed" />
    </RecordActions>
  </Record>
</template>

<script>
import { actions, getters } from '@utils'
import ImageTags from '@components/ImageTags'
import Record from '@components/Record'
import RecordActions from '@components/RecordActions'
import Set from '@components/Set'

export default {
  components: {
    ImageTags,
    Record,
    RecordActions,
    Set,
  },
  props: {
    image: Object,
  },
  data() {
    return {
      labelName: null,
      isSaving: false,
    }
  },
  computed: getters('getFileUrl'),
  methods: {
    saveFileName() {
      const label = this.labelName

      if (!label) {
        // reset
        this.label = this.image.label || this.image.name
        return
      }

      if ([this.image.label, this.image.name].includes(label)) {
        return
      }

      return this.patchFile({ label })
    },
    setDoEmbed(doEmbed) {
      return this.patchFile({ doEmbed })
    },
    patchFile(data) {
      return this.$wrap(
        () => this.PATCH_FILE({
          id: this.image.id,
          ...data,
        }),
        'isSaving',
      )
    },
    ...actions('PATCH_FILE'),
  },
  watch: {
    'image.label': {
      immediate: true,
      handler(label) {
        this.labelName = label
      },
    },
    'image.name': {
      immediate: true,
      handler(name) {
        if (this.image.label) return

        this.labelName = name
      },
    },
  },
}
</script>

<style lang="scss">
.Box.Record.RecordImage {
  > .body {
    margin-bottom: 0;

    .image {
      img {
        max-width: 100%;
      }
    }

    .Set {
      margin: 0;

      > .body > .value {
        line-height: 2.5rem;
      }
    }
  }

  .nameLabel {
    font-weight: $medium;

    input {
      border: 0;
      border-radius: 0;
      color: inherit;
      padding-bottom: 0;
      padding-left: 1rem;
      padding-top: 0;
    }

    .Loader {
      position: absolute;
      right: 1rem;
      top: 0.75rem;
    }

    &.rawName {
      color: $text-color-light;
    }
  }

  .ImageTags {
    border-top: 1px solid $border-color;
    padding: $grid-unit-half;
  }
}
</style>

<i18n>
{
  "en": {
    "embeddings": "Embeddings",
    "jwt": "JWT token",
    "name": "Image file name"
  }
}
</i18n>
